import type { PlayerLimitGrace } from "@magicweave/api";

/**
 * The share of the plan's player limit at which Usage starts warning — the
 * same 80% Pricing v3 emails the owner at. A presentation threshold, not a
 * rule: the only rule is the server's, that sign-ups close at the limit.
 */
const PLAYERS_NEAR = 0.8;

/**
 * What the gate compares: onboarded less what staff have forgiven, never
 * below zero. Every screen that shows a player count shows this one.
 */
export function countedPlayers(usage: { onboarded: number; forgiven: number }): number {
  return Math.max(usage.onboarded - usage.forgiven, 0);
}

/**
 * Where an organisation stands against its lifetime player limit.
 *
 * `closed` is the plan's runway, and outranks everything: sign-ups are shut in
 * every environment whatever the count says. `grace` is the server saying it
 * is still admitting past the limit — read off `grace`, never worked out from
 * the count, because whether grace has already been spent on this limit is
 * the server's to know.
 */
export function playerStanding(usage: {
  onboarded: number;
  limit?: number | null;
  grace?: PlayerLimitGrace | null;
  signups_closed?: boolean;
}): "none" | "ok" | "near" | "grace" | "full" | "closed" {
  if (usage.signups_closed) return "closed";
  if (usage.limit === null || usage.limit === undefined) return "none";
  if (usage.grace) return "grace";
  if (usage.onboarded >= usage.limit) return "full";
  return usage.onboarded >= usage.limit * PLAYERS_NEAR ? "near" : "ok";
}
